/* unplugin-vue-components disabled */import { render } from "./topic-suggestion.vue?vue&type=template&id=77eef64b&scoped=true"
import script from "./topic-suggestion.vue?vue&type=script&lang=js"
export * from "./topic-suggestion.vue?vue&type=script&lang=js"

import "./topic-suggestion.vue?vue&type=style&index=0&id=77eef64b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77eef64b"],['__file',"src/components/search-dropdown/topic-suggestion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77eef64b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77eef64b', __exports__)) {
    api.reload('77eef64b', __exports__)
  }
  
  module.hot.accept("./topic-suggestion.vue?vue&type=template&id=77eef64b&scoped=true", () => {
    api.rerender('77eef64b', render)
  })

}


export default __exports__